import { AppListLight } from '@/components/applications/app-list.light';
import { useGetApplications } from '@/hooks/api/applications.hook';

export function ServicesNavSheetAppsContent() {
  const { data: apps, isLoading } = useGetApplications();
  return <AppListLight apps={apps ?? []} isLoading={isLoading} />;
}
